import React from "react";
import PropTypes from "prop-types";

import Swiper from "components/Swiper";

const defaultOptions = {
  speed: 200,
  easing: 'ease-out',
  slidesPerView: 1,
  initialSlide: 0,
  resistanceRatio: 0.5
}

/**
 * Wrapper for Swiper component (which is itself a wrapper for the swiper library).
 * Sets some sensible default options and provides a convenient onChange callback hook.
 * Also applies BEM-y classNames to the swiper DOM structure.
 * Forwards the swiper instance ref if required.
 */
export default class Carousel extends React.Component {

    static propTypes = {
      cssBlockName: PropTypes.string,
      swiperOptions: PropTypes.object,
      refSwiper: PropTypes.func,
      onChange: PropTypes.func,
      onAfterChange: PropTypes.func,
      activeIndex: PropTypes.number
    }
    
    lastActiveIndexProp = null;
    prevSwiperActiveIndex = 0;
    
    onChange = () => {
      if (this.props.onChange) {
        this.props.onChange(this.swiper.activeIndex, this.prevSwiperActiveIndex);
      }
    }

    onAfterChange = () => {
      if (this.props.onAfterChange) {
        this.props.onAfterChange(this.swiper.activeIndex, this.prevSwiperActiveIndex);
      }
      this.prevSwiperActiveIndex = this.swiper.activeIndex;
    }

    refSwiper = swiper => {
      this.swiper = swiper;
      this.swiper.on("slideChange", this.onChange);
      // onAfterChange is important because it fires on slideChangeTransitionEnd, not slideChange
      // if a re-render is triggered on slideChange then the trasition will be interrupted
      this.swiper.on("slideChangeTransitionEnd", this.onAfterChange);
      if (this.props.refSwiper) {
        this.props.refSwiper(swiper);
      }
    }

    getClassNames() {
      const { cssBlockName } = this.props;
      const classNames = {
        container: "carousel",
        wrapper: "carousel__wrapper",
        slide: "carousel__slide"
      }
      if (cssBlockName !== undefined) {
        classNames.container += ` ${cssBlockName}__carousel`;
        classNames.wrapper += ` ${cssBlockName}__carousel-wrapper`;
        classNames.slide += ` ${cssBlockName}__slide`;
      }
      return classNames;
    }

    getOptions() {
      return {
        ...defaultOptions,
        ...this.props.swiperOptions
      }
    }
    
    /**
     * After props change, sync swiper to activeIndex prop.
     * This allows the active slide to be controlled from outside.
     */
    componentDidUpdate() {
      const { activeIndex } = this.props;
      if (activeIndex !== undefined && activeIndex !== this.lastActiveIndexProp) {
        this.swiper.slideTo(activeIndex);
        this.lastActiveIndexProp = activeIndex;
      }
    }

    /**
     * Destroy swiper instance on component unmount.
     * Mainly so that all event listeners are cleaned up.
     */
    componentWillUnmount() {
      const destroyInstance = true;
      const cleanStyles = false;
      this.swiper.destroy(destroyInstance, cleanStyles);
    }

    render() {
      return (
        <Swiper
          classNames={this.getClassNames()}
          options={this.getOptions()}
          refSwiper={this.refSwiper}
        >
          { this.props.children }
        </Swiper>
      )
    }

}



// WEBPACK FOOTER //
// ./src/components/Carousel.js